import { Service } from 'wax-prosemirror-core';
import { v4 as uuidv4 } from 'uuid';
import { bibliographyNode } from './bibliographyNode';
import { citationMark } from './citationSchema';
import { getActiveStyle, generateInTextCitation, generateBibliography } from './CitationStyleService';

class CitationService extends Service {
  register() {
    const createCitation = this.createCitation.bind(this);
    const openReferenceManager = this.openReferenceManager.bind(this);

    this.container.bind('CreateCitation').toConstantValue(createCitation);
    this.container.bind('OpenReferenceManager').toConstantValue(openReferenceManager);

    const createMark = this.container.get('CreateMark');
    createMark({ citation: citationMark }, { toWaxSchema: false });

    const createNode = this.container.get('CreateNode');
    createNode({ bibliography: bibliographyNode }, { toWaxSchema: false });
  }

  /**
   * Insert a citation mark into the document.
   *
   * @param {EditorView} view
   * @param {string}     citationId  – UUID for this citation group
   * @param {string}     citationText – pre-formatted text, e.g. "[1]" or "(Smith, 2024)"
   */
  createCitation(view, citationId, citationText) {
    const { state, dispatch } = view;
    const { schema, tr, selection } = state;

    if (!schema.marks.citation) {
      console.error('Citation mark not found in schema');
      return false;
    }

    const mark = schema.marks.citation.create({
      citationId,
      citationText,
    });

    const { from, to } = selection;

    if (from === to) {
      const node = schema.text(citationText, [mark]);
      dispatch(tr.replaceSelectionWith(node, false));
    } else {
      dispatch(tr.addMark(from, to, mark));
    }

    return true;
  }

  openReferenceManager() {
    window.dispatchEvent(new CustomEvent('openReferenceManager'));
  }
}

export default CitationService;
